import { ADD_USER_REQUEST, ADD_USER_SUCCESS, ADD_USER_ERROR, RESET_ADD_USER } from "../actions/addUser"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const addUser = (state = initialState, action) => {
    switch (action.type) {
        case ADD_USER_REQUEST:
            return {
                ...state,
                loading: true
            }

        case ADD_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case ADD_USER_ERROR:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case RESET_ADD_USER:
            return {
                ...state,
                loading: false,
                data: null,
                error: null
            }

        default:
            return state;
    }
}

export default addUser